<div>
  <div class="mat-app-background">
    <app-nav></app-nav>
      <div class="main-container">
        <router-outlet></router-outlet>
      </div>
    <app-footer *ngIf="false"></app-footer>
  </div>
</div>
